module.exports = {
	"id": "MS",
	"name": "Montserrat",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.007228,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.028912,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.021684,
			"33": null,
			"34": null,
			"35": 0.007228,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": 0.021684,
			"43": 0.10842,
			"44": null,
			"45": 0.014456,
			"46": 0.166244,
			"47": 0.137332,
			"48": 0.065052,
			"49": 0.238524,
			"50": 0.007228,
			"51": 0.766168,
			"52": 0.411996,
			"53": 35.641268,
			"54": 17.137588,
			"55": 0.122876,
			"56": 0.122876,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.007228,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": 0.115648,
			"44": null,
			"45": null,
			"46": null,
			"47": 0.25298,
			"48": 0.411996,
			"49": 3.816384,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.021684,
			"30": 0.007228,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.043368,
			"38": null,
			"39": null,
			"40": 0.368628,
			"41": 0.195156,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.028912,
			"9": null,
			"10": 0.43368,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": 0.267436
		},
		"ios_saf": {
			"8": 0,
			"10": 2.70693748876,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0729488330558,
			"8.1-8.4": 0.134769878018,
			"9.0-9.2": 0.064293886761,
			"9.3": 0.980893913405
		},
		"android": {
			"3": 0,
			"4": 0.0249283385013,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00311604231266,
			"4.1": 0.0899200781654,
			"4.2-4.3": 0.224800195413,
			"4.4": 0.515482428295,
			"4.4.3-4.4.4": 0.519933917313
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.102803907965,
			"9": 0.367156814159,
			"10": 0.0514019539823,
			"11": 3.62750932389,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00420713513514,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000116864864865
		},
		"edge": {
			"12": 0.043368,
			"13": 0.860132,
			"14": 1.676896
		},
		"ie_mob": {
			"10": 0.0617871267606,
			"11": 0.251561873239
		},
		"bb": {
			"7": 0.016638,
			"10": null
		},
		"samsung": {
			"0": 1.752536
		},
		"and_uc": {
			"0": 0.490821
		},
		"op_mini": {
			"0": 0.056682
		},
		"and_chr": {
			"0": 23.16215
		},
		"and_ff": {
			"0": 0.133104
		}
	},
	"total": 98.993989
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MS.json
 ** module id = 596
 ** module chunks = 0
 **/